export default __webpack_public_path__ + "static/media/team-call.d2d7f2fa.wav";